export default "__VITE_ASSET__B0RCPb$P__"